/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EditorialAmbassadorSilverResponsePaging } from '../../models/editorial-ambassador-silver-response-paging';

export interface GetEditorialAmbassadorsSilver$Params {
  page: number;
  pageSize: number;
  orderBy?: string;
  filter?: string;
}

export function getEditorialAmbassadorsSilver(http: HttpClient, rootUrl: string, params: GetEditorialAmbassadorsSilver$Params, context?: HttpContext): Observable<StrictHttpResponse<EditorialAmbassadorSilverResponsePaging>> {
  const rb = new RequestBuilder(rootUrl, getEditorialAmbassadorsSilver.PATH, 'get');
  if (params) {
    rb.query('page', params.page, {});
    rb.query('pageSize', params.pageSize, {});
    rb.query('orderBy', params.orderBy, {});
    rb.query('filter', params.filter, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EditorialAmbassadorSilverResponsePaging>;
    })
  );
}

getEditorialAmbassadorsSilver.PATH = '/api/editorial/ambassadors/silver';
